module.exports = __webpack_public_path__ + "img/card-purple.44f988d1.png";